
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.54 31.16a4.39 4.39 0 006.18 6.23l18-17.86A9.3 9.3 0 0038.28 7.71l-7 5.56-4.44-4.47 5.61-7a9.3 9.3 0 00-11.91 11.5z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"5.69","cy":"34.22","r":"1.5","fill":"#241f21"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M23.83 16.22L8.46 31.47"}})])
          )
        }
      }
    